import Valkyrie from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import PropTypes from "prop-types";

function NavigationItem({ title, secondary, icon, color, avatar, ...props }) {
  const theme = useTheme();

  return (
    <ListItem
      disablePadding
      sx={[
        color === "danger" && {
          color: (theme) => theme.vars.palette.error.main,
        },
        avatar && {
          [theme.breakpoints.up("md")]: {
            minHeight: "48px !important",
          },
        },
      ]}
    >
      <ListItemButton
        sx={[
          avatar && {
            [theme.breakpoints.up("md")]: {
              minHeight: "48px !important",
            },
          },
        ]}
        {...props}
      >
        {avatar ? (
          <ListItemAvatar sx={{ minWidth: 34 }}>{avatar}</ListItemAvatar>
        ) : (
          <ListItemIcon
            sx={[
              { color: "inherit" },
              color === "danger" && {
                color: (theme) => `${theme.vars.palette.error.main} !important`,
              },
            ]}
          >
            <Valkyrie icon={icon} />
          </ListItemIcon>
        )}
        <ListItemText primary={title} secondary={secondary} />
      </ListItemButton>
    </ListItem>
  );
}

NavigationItem.propTypes = {
  title: PropTypes.string,
  secondary: PropTypes.string,
  avatar: PropTypes.node,
  icon: PropTypes.object,
  color: PropTypes.string,
};

export default NavigationItem;
